import React from "react"

const RoundedArrow = ({ color }) => (
  <svg
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.3 18.7602C1.97968 19.0806 1.47968 19.0806 1.16016 18.7602C0.839842 18.4399 0.839842 17.9399 1.16016 17.6204L8.79996 10L1.16016 2.36021C0.839841 2.03989 0.839841 1.53989 1.16016 1.22037C1.32032 1.06022 1.52032 0.980534 1.72032 0.980534C1.92032 0.980534 2.12032 1.06022 2.28048 1.22037L11.0601 9.99997L2.3 18.7602Z"
      fill={color ?? "#000"}
    />
  </svg>
)

export default RoundedArrow
